var _dec, _class, _PlayerControls;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyle, jsx } from '@instructure/emotion';
import { isTouchDevice } from "../../utils";
import PlayPauseButton from './PlayPauseButton';
import Timebar from './Timebar';
import Volume from './VolumeContainer';
import FullScreenButton from './FullScreenButton';
import MediaContext from '../Player/MediaContext';
import CaptionsToggle from './CaptionsToggle';
import PlayerSettings from './PlayerSettings';
import generateComponentTheme from './theme';
import generateStyle from './styles';

/**
---
parent: Player
---
**/
let PlayerControls = (_dec = withStyle(generateStyle, generateComponentTheme), _dec(_class = (_PlayerControls = class PlayerControls extends Component {
  constructor(...args) {
    super(...args);
    this.handleOnClick = showControls => e => {
      e.stopPropagation();
      showControls();
    };
  }
  componentDidMount() {
    this.props.makeStyles();
  }
  componentDidUpdate() {
    this.props.makeStyles();
  }
  render() {
    const _this$props = this.props,
      styles = _this$props.styles,
      focusEnabled = _this$props.focusEnabled;
    return jsx(MediaContext.Consumer, null, ({
      state,
      actions
    }) => {
      const showControls = state.showControls;

      /* eslint-disable jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */
      /* eslint-disable jsx-a11y/no-static-element-interactions, jsx-a11y/mouse-events-have-key-events */
      return jsx("div", {
        inert: focusEnabled ? true : void 0,
        css: [styles.container, !showControls && styles.hidden],
        onClick: this.handleOnClick(actions.showControls),
        onMouseEnter: () => {
          !isTouchDevice(window) && actions.setControlHovered(true);
        },
        onMouseLeave: () => {
          !isTouchDevice(window) && actions.setControlHovered(false);
        },
        onTouchStart: () => {
          actions.setControlHovered(true);
        },
        onTouchEnd: () => {
          actions.setControlHovered(false);
        }
      }, this.props.children);
      /* eslint-enable jsx-a11y/no-static-element-interactions, jsx-a11y/mouse-events-have-key-events */
      /* eslint-enable jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */
    });
  }
}, _PlayerControls.displayName = 'PlayerControls', _PlayerControls.propTypes = {
  // eslint-disable-next-line react/require-default-props
  makeStyles: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  styles: PropTypes.object,
  focusEnabled: PropTypes.bool,
  /**
   * Children of the <PlayerControls />
   */
  children: PropTypes.node
}, _PlayerControls.defaultProps = {
  showControls: false,
  focusEnabled: false
}, _PlayerControls.PlayPauseButton = PlayPauseButton, _PlayerControls.Timebar = props => jsx(MediaContext.Consumer, null, ({
  state,
  actions
}) => jsx(Timebar, Object.assign({
  seeking: state.seeking,
  duration: state.duration,
  currentTime: state.currentTime,
  mediaState: state.mediaState,
  buffered: state.buffered,
  videoId: state.videoId,
  onClick: actions.seek
}, props))), _PlayerControls.Volume = Volume, _PlayerControls.FullScreenButton = FullScreenButton, _PlayerControls.PlayerSettings = PlayerSettings, _PlayerControls.CaptionsToggle = CaptionsToggle, _PlayerControls)) || _class);
export default PlayerControls;